import { useEffect, useRef, useState } from "react";
import initFinancialApp from "./legacyApp";
import "./styles.css";

export default function App() {
  const [markup, setMarkup] = useState("");
  const cleanupRef = useRef(null);

  useEffect(() => {
    let active = true;

    fetch("/legacy-markup.html")
      .then((response) => response.text())
      .then((html) => {
        if (active) {
          setMarkup(html);
        }
      })
      .catch(() => {
        if (active) {
          setMarkup("<main class='container'><p>Errore nel caricamento del markup.</p></main>");
        }
      });

    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    if (!markup) {
      return undefined;
    }

    const raf = requestAnimationFrame(() => {
      cleanupRef.current = initFinancialApp();
    });

    return () => {
      cancelAnimationFrame(raf);
      if (typeof cleanupRef.current === "function") {
        cleanupRef.current();
      }
      cleanupRef.current = null;
    };
  }, [markup]);

  return <div dangerouslySetInnerHTML={{ __html: markup }} />;
}
